import { TextSelection } from 'prosemirror-state'

import { Command } from 'common/Prose/Commands'

export const deleteZeroWidthSpaceWithoutInlineCode =
  (direction: 'left' | 'right'): Command =>
  (
    {
      doc,
      schema,
      selection: {
        $from: { nodeAfter, nodeBefore },
        empty,
        from,
      },
      tr,
    },
    dispatch,
  ) => {
    if (!empty) return false

    // check if we are before or after a zero-width space
    if (direction === 'right' && !nodeAfter?.textContent.startsWith('\u200B')) return false
    if (direction === 'left' && !nodeBefore?.textContent.endsWith('\u200B')) return false

    // check if the zero-width space delimits inline code, if yes abort
    if (
      (from >= 1 && schema.marks.code.isInSet(doc.resolve(from - 1).nodeBefore?.marks || [])) ||
      (from <= doc.nodeSize - 1 && schema.marks.code.isInSet(doc.resolve(from + 1).nodeAfter?.marks || []))
    )
      return false

    tr.setMeta('addToHistory', false)
    if (direction === 'right') {
      dispatch?.(
        tr.delete(from, from + 1).setSelection(TextSelection.create(tr.doc, Math.min(from + 1, doc.nodeSize - 1))),
      )
    } else if (direction === 'left') {
      dispatch?.(tr.delete(from - 1, from).setSelection(TextSelection.create(tr.doc, Math.max(from - 2, 0))))
    }

    return true
  }
